module.exports = __webpack_public_path__ + "img/JZ.10f8502a.png";